import React, { useState, useRef, useEffect } from 'react';
import { Search, Settings, X, Plus, Upload, HardDriveUpload, Filter } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { MassOperationPanel } from '../../../components/common/MassOperation/MassOperation';
import PopUpModal from '../../../components/PopUpModal/PopUpModal';
import SubHeader from '../../../components/common/SubHeader/SubHeader';
import Button from '../../../components/common/Button';
import FilterSearch from '../Forms/FilterSearch';
import AddNewTask from '../Forms/AddNewTask';
import CustomSearch from '../Forms/CustomSearch';

const TaskHeader = ({
    searchQuery,
    setSearchQuery,
    totalTasks,
    viewMode,
    setViewMode,
    selectedCount = 0,
    onClearSelection,
    onMassAction,
    isAllSelectedAcrossPages,
    setIsAllSelectedAcrossPages,
    advanceFilterFields = [],
    onAdvanceFilterSubmit = null,
    onCustomSearchSubmit = null,
    onCustomSearchClear = null,
    onExport = null,
    onCustomDownload = null,
    onAddTask = null,
    showSearch = true,
    showAdvanceFilter = true,
    showCustomSearch = true
}) => {
    const actionTrayRef = useRef(null);

    const [showSearchFilterForm, setShowSearchFilterForm] = useState(false);
    const [showActionTray, setShowActionTray] = useState(false);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (actionTrayRef.current && !actionTrayRef.current.contains(e.target)) {
                setShowActionTray(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // ... (massPanel remains unchanged)
    const massPanel = (
        <div className="w-full flex items-center">
            <MassOperationPanel
                selectedCount={selectedCount}
                totalCount={totalTasks}
                variant="header"
                onClose={onClearSelection}
                onGo={onMassAction}
            />
            {isAllSelectedAcrossPages && (
                <div className="ml-8 flex items-center gap-2">
                    <span className="text-sm text-emerald-600 font-medium whitespace-nowrap">
                        All {totalTasks} records selected across all pages.
                    </span>
                    <button
                        onClick={() => {
                            setIsAllSelectedAcrossPages(false);
                            onClearSelection();
                        }}
                        className="text-sm font-semibold text-gray-500 hover:text-gray-700 hover:underline transition-all"
                    >
                        Clear selection
                    </button>
                </div>
            )}
        </div>
    );

    return (
        <header className="sticky top-0 z-[100] bg-white border-b border-gray-200">
            <SubHeader
                pageName="Tasks"
                pageCode="PAG10034"
                title="Tasks"
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                searchPlaceholder="Search tasks..."
                viewMode={viewMode}
                setViewMode={setViewMode}
                showViewSwitcher={true}
                showGrid={true}
                showTable={true}
                showCalendar={true}
                showSettings={true}
                showExport={true}
                onExportClick={onExport}
                showCustomExport={true}
                onCustomExportClick={onCustomDownload}
                customMenuItems={null}
                massActionPanel={selectedCount > 0 ? massPanel : null}
                totalCount={totalTasks}
                advanceFilterFields={advanceFilterFields}
                onAdvanceFilterSubmit={onAdvanceFilterSubmit}
                showSearch={showSearch}
                showAdvanceFilter={showAdvanceFilter}
                showCustomSearch={showCustomSearch}
                onCustomSearchSubmit={onCustomSearchSubmit}
                onCustomSearchClear={onCustomSearchClear}
                onAddClick={onAddTask}
                showAddInMenu={false}
            />

            {/* Modals */}
            <PopUpModal isOpen={showSearchFilterForm} onClose={() => setShowSearchFilterForm(false)} title="Filter" size="lg">
                <FilterSearch />
            </PopUpModal>
        </header>
    );
};

export default TaskHeader;
